import { render, staticRenderFns } from "./PaqTerapia.vue?vue&type=template&id=540d34a0&scoped=true"
import script from "./PaqTerapia.vue?vue&type=script&lang=js"
export * from "./PaqTerapia.vue?vue&type=script&lang=js"
import style0 from "./PaqTerapia.vue?vue&type=style&index=0&id=540d34a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d34a0",
  null
  
)

export default component.exports